import BannerSecondary from 'components/features/home/bannerSecondary/BannerSecondary';
import { useEffect, useState } from 'react';
import { useLazyGetSecondaryBannersQuery } from 'redux/services/webService';
import { useLanguage } from 'context/languageContext';
import { accentsTidy } from 'utils/utils';
import UseSEO from 'hooks/useSEO/UseSEO';
import { useNavigate } from 'react-router-dom';
import { RUTAS_GENERALES_MUL2 } from 'utils/constants';

export default function HomeBannersSecundarios() {
  const currentLanguage = useLanguage();
  const [banners, setBanners] = useState([]) as any;
  const [GetSecondaryBanners] = useLazyGetSecondaryBannersQuery();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  const [generateUrl, generateTitleAndMeta, navigateStaticPage] = UseSEO();
  const navigate = useNavigate();

  const getSecondaryBanners = async () => {
    await GetSecondaryBanners({ language: currentLanguage }).then((result) => {
      if (result.isSuccess) {
        setBanners(result.data);
      }
    });
  };

  const handleClick = (url, pageId, newId, title) => {
    accentsTidy(title);
    if (url) {
      window.open(url, '_blank');
    } else if (pageId) {
      navigateStaticPage(pageId);
    } else if (newId) {
      navigate(`${generateUrl(RUTAS_GENERALES_MUL2.emtNewDetail)}${newId}/${accentsTidy(title)}`);
    }
  };

  useEffect(() => {
    getSecondaryBanners();
  }, [currentLanguage]);

  return (
    <div className='container homeScreen_bannersList'>
      {banners &&
        banners.length > 0 &&
        banners.map((banner, index) => (
          <BannerSecondary
            key={banner.title + index}
            title={banner.title}
            text={banner.description}
            iconId={banner.iconId}
            url={banner.url}
            selected={false}
            grid='col-3--grid'
            onClick={() => handleClick(banner.url, banner.pageId, banner.newsId, banner.title)}
          />
        ))}
    </div>
  );
}
